window.IR_SECOND_PAGE_PRINTER_CATALOGS = window.IR_SECOND_PAGE_PRINTER_CATALOGS || {};
window.IR_SECOND_PAGE_PRINTER_CATALOGS["hpprinter"] = {
  "groupCount": 34,
  "modelCount": 320,
  "groups": [
    {
      "order": 1,
      "name": "Business-Inkjetシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Business-Inkjet-1200",
          "shopifyUrl": "/collections/business-inkjet-1200"
        },
        {
          "order": 2,
          "model": "Business-Inkjet-1200d",
          "shopifyUrl": "/collections/business-inkjet-1200d"
        },
        {
          "order": 3,
          "model": "Business-Inkjet-1200dtn",
          "shopifyUrl": "/collections/business-inkjet-1200dtn"
        },
        {
          "order": 4,
          "model": "Business-Inkjet-1200dtwn",
          "shopifyUrl": "/collections/business-inkjet-1200dtwn"
        },
        {
          "order": 5,
          "model": "Business-Inkjet-2200",
          "shopifyUrl": "/collections/business-inkjet-2200"
        },
        {
          "order": 6,
          "model": "Business-Inkjet-2300",
          "shopifyUrl": "/collections/business-inkjet-2300"
        },
        {
          "order": 7,
          "model": "Business-Inkjet-2800",
          "shopifyUrl": "/collections/business-inkjet-2800"
        },
        {
          "order": 8,
          "model": "Business-Inkjet-2800dtn",
          "shopifyUrl": "/collections/business-inkjet-2800dtn"
        }
      ]
    },
    {
      "order": 3,
      "name": "CPシリーズ",
      "models": [
        {
          "order": 1,
          "model": "cp1700",
          "shopifyUrl": "/collections/cp1700"
        }
      ]
    },
    {
      "order": 4,
      "name": "Designjetシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Designjet-10ps",
          "shopifyUrl": "/collections/designjet-10ps"
        },
        {
          "order": 2,
          "model": "Designjet-20ps",
          "shopifyUrl": "/collections/designjet-20ps"
        },
        {
          "order": 3,
          "model": "Designjet-30",
          "shopifyUrl": "/collections/designjet-30"
        },
        {
          "order": 4,
          "model": "Designjet-50ps",
          "shopifyUrl": "/collections/designjet-50ps"
        },
        {
          "order": 5,
          "model": "Designjet-70",
          "shopifyUrl": "/collections/designjet-70"
        },
        {
          "order": 6,
          "model": "Designjet-90r",
          "shopifyUrl": "/collections/designjet-90r"
        },
        {
          "order": 7,
          "model": "Designjet-110",
          "shopifyUrl": "/collections/designjet-110"
        },
        {
          "order": 8,
          "model": "Designjet-110-Plus",
          "shopifyUrl": "/collections/designjet-110-plus"
        },
        {
          "order": 9,
          "model": "Designjet-110plus-NR",
          "shopifyUrl": "/collections/designjet-110plus-nr"
        },
        {
          "order": 10,
          "model": "Designjet-110plus-R",
          "shopifyUrl": "/collections/designjet-110plus-r"
        },
        {
          "order": 11,
          "model": "Designjet-111Roll",
          "shopifyUrl": "/collections/designjet-111roll"
        },
        {
          "order": 12,
          "model": "Designjet-111Tray",
          "shopifyUrl": "/collections/designjet-111tray"
        },
        {
          "order": 13,
          "model": "Designjet-130",
          "shopifyUrl": "/collections/designjet-130"
        },
        {
          "order": 14,
          "model": "Designjet-500",
          "shopifyUrl": "/collections/designjet-500"
        },
        {
          "order": 15,
          "model": "Designjet-500-in-Roll-Printer",
          "shopifyUrl": "/collections/designjet-500-in-roll-printer"
        },
        {
          "order": 16,
          "model": "Designjet-500-mono",
          "shopifyUrl": "/collections/designjet-500-mono"
        },
        {
          "order": 17,
          "model": "Designjet-500plus",
          "shopifyUrl": "/collections/designjet-500plus"
        },
        {
          "order": 18,
          "model": "Designjet-500ps",
          "shopifyUrl": "/collections/designjet-500ps"
        },
        {
          "order": 19,
          "model": "Designjet-510",
          "shopifyUrl": "/collections/designjet-510"
        },
        {
          "order": 20,
          "model": "Designjet-800",
          "shopifyUrl": "/collections/designjet-800"
        },
        {
          "order": 21,
          "model": "Designjet-800ps",
          "shopifyUrl": "/collections/designjet-800ps"
        },
        {
          "order": 22,
          "model": "Designjet-815mfp",
          "shopifyUrl": "/collections/designjet-815mfp"
        },
        {
          "order": 23,
          "model": "Designjet-820-MFP",
          "shopifyUrl": "/collections/designjet-820-mfp"
        }
      ]
    },
    {
      "order": 5,
      "name": "Designjet-Tシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Designjet-111",
          "shopifyUrl": "/collections/designjet-111"
        },
        {
          "order": 2,
          "model": "DesignJet-T120",
          "shopifyUrl": "/collections/designjet-t120"
        },
        {
          "order": 3,
          "model": "DesignJet-T125",
          "shopifyUrl": "/collections/designjet-t125"
        },
        {
          "order": 4,
          "model": "DesignJet-T130",
          "shopifyUrl": "/collections/designjet-t130"
        },
        {
          "order": 5,
          "model": "DesignJet-T520",
          "shopifyUrl": "/collections/designjet-t520"
        },
        {
          "order": 6,
          "model": "DesignJet-T530",
          "shopifyUrl": "/collections/designjet-t530"
        },
        {
          "order": 7,
          "model": "Designjet-T610",
          "shopifyUrl": "/collections/designjet-t610"
        },
        {
          "order": 8,
          "model": "Designjet-T620",
          "shopifyUrl": "/collections/designjet-t620"
        },
        {
          "order": 9,
          "model": "Designjet-T770",
          "shopifyUrl": "/collections/designjet-t770"
        },
        {
          "order": 10,
          "model": "Designjet-T770HDD",
          "shopifyUrl": "/collections/designjet-t770hdd"
        },
        {
          "order": 11,
          "model": "Designjet-T790-ePrinter",
          "shopifyUrl": "/collections/designjet-t790-eprinter"
        },
        {
          "order": 12,
          "model": "Designjet-T1100",
          "shopifyUrl": "/collections/designjet-t1100"
        },
        {
          "order": 13,
          "model": "Designjet-T1100mfp",
          "shopifyUrl": "/collections/designjet-t1100mfp"
        },
        {
          "order": 14,
          "model": "Designjet-T1100ps",
          "shopifyUrl": "/collections/designjet-t1100ps"
        },
        {
          "order": 15,
          "model": "Designjet-T1120",
          "shopifyUrl": "/collections/designjet-t1120"
        },
        {
          "order": 16,
          "model": "Designjet-T1120ps",
          "shopifyUrl": "/collections/designjet-t1120ps"
        },
        {
          "order": 17,
          "model": "Designjet-T1120SD-MFP",
          "shopifyUrl": "/collections/designjet-t1120sd-mfp"
        },
        {
          "order": 18,
          "model": "Designjet-T1200",
          "shopifyUrl": "/collections/designjet-t1200"
        },
        {
          "order": 19,
          "model": "Designjet-T1200HD-MFP",
          "shopifyUrl": "/collections/designjet-t1200hd-mfp"
        },
        {
          "order": 20,
          "model": "Designjet-T1300-ePrinter",
          "shopifyUrl": "/collections/designjet-t1300-eprinter"
        },
        {
          "order": 21,
          "model": "Designjet-T1300ps-ePrinter",
          "shopifyUrl": "/collections/designjet-t1300ps-eprinter"
        },
        {
          "order": 22,
          "model": "Designjet-T2300-eMFP",
          "shopifyUrl": "/collections/designjet-t2300-emfp"
        },
        {
          "order": 23,
          "model": "Designjet-T2300ps-eMFP",
          "shopifyUrl": "/collections/designjet-t2300ps-emfp"
        }
      ]
    },
    {
      "order": 6,
      "name": "Deskjetシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Deskjet-340",
          "shopifyUrl": "/collections/deskjet-340"
        },
        {
          "order": 2,
          "model": "Deskjet-450cbi",
          "shopifyUrl": "/collections/deskjet-450cbi"
        },
        {
          "order": 3,
          "model": "Deskjet-460c",
          "shopifyUrl": "/collections/deskjet-460c"
        },
        {
          "order": 4,
          "model": "Deskjet-460cb",
          "shopifyUrl": "/collections/deskjet-460cb"
        },
        {
          "order": 5,
          "model": "Deskjet-505J",
          "shopifyUrl": "/collections/deskjet-505j"
        },
        {
          "order": 6,
          "model": "Deskjet-560J",
          "shopifyUrl": "/collections/deskjet-560j"
        },
        {
          "order": 7,
          "model": "Deskjet-710c",
          "shopifyUrl": "/collections/deskjet-710c"
        },
        {
          "order": 8,
          "model": "Deskjet-720c",
          "shopifyUrl": "/collections/deskjet-720c"
        },
        {
          "order": 9,
          "model": "Deskjet-815c",
          "shopifyUrl": "/collections/deskjet-815c"
        },
        {
          "order": 10,
          "model": "Deskjet-815c-SW",
          "shopifyUrl": "/collections/deskjet-815c-sw"
        },
        {
          "order": 11,
          "model": "Deskjet-840c",
          "shopifyUrl": "/collections/deskjet-840c"
        },
        {
          "order": 12,
          "model": "Deskjet-845c",
          "shopifyUrl": "/collections/deskjet-845c"
        },
        {
          "order": 13,
          "model": "Deskjet-850c",
          "shopifyUrl": "/collections/deskjet-850c"
        },
        {
          "order": 14,
          "model": "Deskjet-880c",
          "shopifyUrl": "/collections/deskjet-880c"
        },
        {
          "order": 15,
          "model": "Deskjet-895cxi",
          "shopifyUrl": "/collections/deskjet-895cxi"
        },
        {
          "order": 16,
          "model": "Deskjet-930c",
          "shopifyUrl": "/collections/deskjet-930c"
        },
        {
          "order": 17,
          "model": "Deskjet-948c",
          "shopifyUrl": "/collections/deskjet-948c"
        },
        {
          "order": 18,
          "model": "Deskjet-955c",
          "shopifyUrl": "/collections/deskjet-955c"
        },
        {
          "order": 19,
          "model": "Deskjet-955c-AP",
          "shopifyUrl": "/collections/deskjet-955c-ap"
        },
        {
          "order": 20,
          "model": "Deskjet-957c",
          "shopifyUrl": "/collections/deskjet-957c"
        },
        {
          "order": 21,
          "model": "Deskjet-957c-AP",
          "shopifyUrl": "/collections/deskjet-957c-ap"
        },
        {
          "order": 22,
          "model": "Deskjet-970cxi",
          "shopifyUrl": "/collections/deskjet-970cxi"
        },
        {
          "order": 23,
          "model": "Deskjet-990cm‐series",
          "shopifyUrl": "/collections/deskjet-990cm-series"
        },
        {
          "order": 24,
          "model": "Deskjet-990cxi",
          "shopifyUrl": "/collections/deskjet-990cxi"
        },
        {
          "order": 25,
          "model": "Deskjet-1120c",
          "shopifyUrl": "/collections/deskjet-1120c"
        },
        {
          "order": 26,
          "model": "Deskjet-1125c",
          "shopifyUrl": "/collections/deskjet-1125c"
        },
        {
          "order": 27,
          "model": "Deskjet-1220c",
          "shopifyUrl": "/collections/deskjet-1220c"
        },
        {
          "order": 28,
          "model": "Deskjet-2050",
          "shopifyUrl": "/collections/deskjet-2050"
        },
        {
          "order": 29,
          "model": "Deskjet-3070A",
          "shopifyUrl": "/collections/deskjet-3070a"
        },
        {
          "order": 30,
          "model": "Deskjet-3420",
          "shopifyUrl": "/collections/deskjet-3420"
        },
        {
          "order": 31,
          "model": "Deskjet-3520",
          "shopifyUrl": "/collections/deskjet-3520"
        },
        {
          "order": 32,
          "model": "Deskjet-D4160",
          "shopifyUrl": "/collections/deskjet-d4160"
        },
        {
          "order": 33,
          "model": "Deskjet-5160",
          "shopifyUrl": "/collections/deskjet-5160"
        },
        {
          "order": 34,
          "model": "Deskjet-5550",
          "shopifyUrl": "/collections/deskjet-5550"
        },
        {
          "order": 35,
          "model": "Deskjet-5551",
          "shopifyUrl": "/collections/deskjet-5551"
        },
        {
          "order": 36,
          "model": "Deskjet-5650",
          "shopifyUrl": "/collections/deskjet-5650"
        },
        {
          "order": 37,
          "model": "Deskjet-5740",
          "shopifyUrl": "/collections/deskjet-5740"
        },
        {
          "order": 38,
          "model": "Deskjet-5850",
          "shopifyUrl": "/collections/deskjet-5850"
        },
        {
          "order": 39,
          "model": "Deskjet-6840",
          "shopifyUrl": "/collections/deskjet-6840"
        }
      ]
    },
    {
      "order": 7,
      "name": "Deskwriterシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Deskwriter-310",
          "shopifyUrl": "/collections/deskwriter-310"
        },
        {
          "order": 2,
          "model": "Deskwriter-320",
          "shopifyUrl": "/collections/deskwriter-320"
        },
        {
          "order": 3,
          "model": "Deskwriter-540",
          "shopifyUrl": "/collections/deskwriter-540"
        },
        {
          "order": 4,
          "model": "Deskwriter-550C",
          "shopifyUrl": "/collections/deskwriter-550c"
        },
        {
          "order": 5,
          "model": "Deskwriter-560C",
          "shopifyUrl": "/collections/deskwriter-560c"
        },
        {
          "order": 6,
          "model": "Deskwriter-DWC",
          "shopifyUrl": "/collections/deskwriter-dwc"
        }
      ]
    },
    {
      "order": 8,
      "name": "ENVYシリーズ",
      "models": [
        {
          "order": 1,
          "model": "ENVY100",
          "shopifyUrl": "/collections/envy100"
        },
        {
          "order": 2,
          "model": "ENVY110",
          "shopifyUrl": "/collections/envy110"
        },
        {
          "order": 3,
          "model": "ENVY120",
          "shopifyUrl": "/collections/envy120"
        },
        {
          "order": 4,
          "model": "ENVY121",
          "shopifyUrl": "/collections/envy121"
        },
        {
          "order": 5,
          "model": "ENVY4500",
          "shopifyUrl": "/collections/envy4500"
        },
        {
          "order": 6,
          "model": "ENVY4520",
          "shopifyUrl": "/collections/envy4520"
        },
        {
          "order": 7,
          "model": "ENVY5020",
          "shopifyUrl": "/collections/envy5020"
        },
        {
          "order": 8,
          "model": "ENVY5530",
          "shopifyUrl": "/collections/envy5530"
        },
        {
          "order": 9,
          "model": "ENVY6020",
          "shopifyUrl": "/collections/envy6020"
        },
        {
          "order": 10,
          "model": "ENVY-Photo-6220",
          "shopifyUrl": "/collections/envy-photo-6220"
        },
        {
          "order": 11,
          "model": "ENVY-Pro6420",
          "shopifyUrl": "/collections/envy-pro6420"
        }
      ]
    },
    {
      "order": 9,
      "name": "MPRシリーズ(SONY)",
      "models": [
        {
          "order": 1,
          "model": "MPR-705",
          "shopifyUrl": "/collections/mpr-705"
        },
        {
          "order": 2,
          "model": "MPR-706",
          "shopifyUrl": "/collections/mpr-706"
        }
      ]
    },
    {
      "order": 10,
      "name": "Officejetシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Officejet-3830",
          "shopifyUrl": "/collections/officejet-3830"
        },
        {
          "order": 2,
          "model": "Officejet-4620",
          "shopifyUrl": "/collections/officejet-4620"
        },
        {
          "order": 3,
          "model": "Officejet-4630",
          "shopifyUrl": "/collections/officejet-4630"
        },
        {
          "order": 4,
          "model": "Officejet-4650",
          "shopifyUrl": "/collections/officejet-4650"
        },
        {
          "order": 5,
          "model": "Officejet-5220",
          "shopifyUrl": "/collections/officejet-5220"
        },
        {
          "order": 6,
          "model": "Officejet-5510",
          "shopifyUrl": "/collections/officejet-5510"
        },
        {
          "order": 7,
          "model": "Officejet-5740",
          "shopifyUrl": "/collections/officejet-5740"
        },
        {
          "order": 8,
          "model": "Officejet-5742",
          "shopifyUrl": "/collections/officejet-5742"
        },
        {
          "order": 9,
          "model": "Officejet-6000",
          "shopifyUrl": "/collections/officejet-6000"
        },
        {
          "order": 10,
          "model": "Officejet-6100",
          "shopifyUrl": "/collections/officejet-6100"
        },
        {
          "order": 11,
          "model": "Officejet-6150",
          "shopifyUrl": "/collections/officejet-6150"
        },
        {
          "order": 12,
          "model": "Officejet-6210",
          "shopifyUrl": "/collections/officejet-6210"
        },
        {
          "order": 13,
          "model": "Officejet-6310",
          "shopifyUrl": "/collections/officejet-6310"
        },
        {
          "order": 14,
          "model": "Officejet-6500",
          "shopifyUrl": "/collections/officejet-6500"
        },
        {
          "order": 15,
          "model": "Officejet-6500A",
          "shopifyUrl": "/collections/officejet-6500a"
        },
        {
          "order": 16,
          "model": "Officejet-7000",
          "shopifyUrl": "/collections/officejet-7000"
        },
        {
          "order": 17,
          "model": "Officejet-7110",
          "shopifyUrl": "/collections/officejet-7110"
        },
        {
          "order": 18,
          "model": "Officejet-7210",
          "shopifyUrl": "/collections/officejet-7210"
        },
        {
          "order": 19,
          "model": "Officejet-7410",
          "shopifyUrl": "/collections/officejet-7410"
        },
        {
          "order": 20,
          "model": "Officejet-7500A",
          "shopifyUrl": "/collections/officejet-7500a"
        },
        {
          "order": 21,
          "model": "Officejet-7610",
          "shopifyUrl": "/collections/officejet-7610"
        },
        {
          "order": 22,
          "model": "Officejet-7612",
          "shopifyUrl": "/collections/officejet-7612"
        }
      ]
    },
    {
      "order": 11,
      "name": "Officejet-Hシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Officejet-H470",
          "shopifyUrl": "/collections/officejet-h470"
        }
      ]
    },
    {
      "order": 12,
      "name": "Officejet-jシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Officejet-j5780",
          "shopifyUrl": "/collections/officejet-j5780"
        },
        {
          "order": 2,
          "model": "Officejet-j6480",
          "shopifyUrl": "/collections/officejet-j6480"
        }
      ]
    },
    {
      "order": 13,
      "name": "Officejet-Mobileシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Officejet-100Mobile",
          "shopifyUrl": "/collections/officejet-100mobile"
        },
        {
          "order": 2,
          "model": "Officejet-150MobileAiO",
          "shopifyUrl": "/collections/officejet-150mobileaio"
        }
      ]
    },
    {
      "order": 14,
      "name": "Officejet-Plusシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Officejet-6500A-Plus",
          "shopifyUrl": "/collections/officejet-6500a-plus"
        }
      ]
    },
    {
      "order": 15,
      "name": "Officejet-Proシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Officejet-Pro-6230",
          "shopifyUrl": "/collections/officejet-pro-6230"
        },
        {
          "order": 2,
          "model": "Officejet-Pro-6830",
          "shopifyUrl": "/collections/officejet-pro-6830"
        },
        {
          "order": 3,
          "model": "Officejet-Pro-8000",
          "shopifyUrl": "/collections/officejet-pro-8000"
        },
        {
          "order": 4,
          "model": "Officejet-Pro-8100",
          "shopifyUrl": "/collections/officejet-pro-8100"
        },
        {
          "order": 5,
          "model": "Officejet-Pro-8600",
          "shopifyUrl": "/collections/officejet-pro-8600"
        },
        {
          "order": 6,
          "model": "Officejet-Pro-8610",
          "shopifyUrl": "/collections/officejet-pro-8610"
        },
        {
          "order": 7,
          "model": "Officejet-Pro-8620",
          "shopifyUrl": "/collections/officejet-pro-8620"
        },
        {
          "order": 8,
          "model": "Officejet-Pro-8630",
          "shopifyUrl": "/collections/officejet-pro-8630"
        },
        {
          "order": 9,
          "model": "Officejet-Pro-8640",
          "shopifyUrl": "/collections/officejet-pro-8640"
        },
        {
          "order": 10,
          "model": "Officejet-Pro-8650",
          "shopifyUrl": "/collections/officejet-pro-8650"
        },
        {
          "order": 11,
          "model": "Officejet-Pro-8660",
          "shopifyUrl": "/collections/officejet-pro-8660"
        },
        {
          "order": 12,
          "model": "Officejet-Pro-8615",
          "shopifyUrl": "/collections/officejet-pro-8615"
        },
        {
          "order": 13,
          "model": "Officejet-Pro-8616",
          "shopifyUrl": "/collections/officejet-pro-8616"
        },
        {
          "order": 14,
          "model": "Officejet-Pro-8625",
          "shopifyUrl": "/collections/officejet-pro-8625"
        },
        {
          "order": 15,
          "model": "Officejet-Pro-251dw",
          "shopifyUrl": "/collections/officejet-pro-251dw"
        },
        {
          "order": 16,
          "model": "Officejet-Pro-276dw",
          "shopifyUrl": "/collections/officejet-pro-276dw"
        }
      ]
    },
    {
      "order": 16,
      "name": "Officejet-Pro-Kシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Officejet-Pro-K850",
          "shopifyUrl": "/collections/officejet-pro-k850"
        },
        {
          "order": 2,
          "model": "Officejet-Pro-K850dn",
          "shopifyUrl": "/collections/officejet-pro-k850dn"
        }
      ]
    },
    {
      "order": 17,
      "name": "Officejet-Pro-Plusシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Officejet-Pro-8500A-Plus",
          "shopifyUrl": "/collections/officejet-pro-8500a-plus"
        },
        {
          "order": 2,
          "model": "Officejet-Pro-8600-Plus",
          "shopifyUrl": "/collections/officejet-pro-8600-plus"
        }
      ]
    },
    {
      "order": 18,
      "name": "Officejet-Pro-Xシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Officejet-Pro-X451dw",
          "shopifyUrl": "/collections/officejet-pro-x451dw"
        },
        {
          "order": 2,
          "model": "Officejet-Pro-X476dw",
          "shopifyUrl": "/collections/officejet-pro-x476dw"
        },
        {
          "order": 3,
          "model": "Officejet-Pro-X551dw",
          "shopifyUrl": "/collections/officejet-pro-x551dw"
        },
        {
          "order": 4,
          "model": "Officejet-Pro-X576dw",
          "shopifyUrl": "/collections/officejet-pro-x576dw"
        }
      ]
    },
    {
      "order": 19,
      "name": "Officejet-Premiumシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Officejet-6700-Premium",
          "shopifyUrl": "/collections/officejet-6700-premium"
        }
      ]
    },
    {
      "order": 20,
      "name": "Officejet-Wirelessシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Officejet-6500-Wireless",
          "shopifyUrl": "/collections/officejet-6500-wireless"
        },
        {
          "order": 2,
          "model": "Officejet-Pro-8500-Wireless",
          "shopifyUrl": "/collections/officejet-pro-8500-wireless"
        }
      ]
    },
    {
      "order": 21,
      "name": "Photosmartシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Photosmart-245",
          "shopifyUrl": "/collections/photosmart-245"
        },
        {
          "order": 2,
          "model": "Photosmart-325",
          "shopifyUrl": "/collections/photosmart-325"
        },
        {
          "order": 3,
          "model": "Photosmart-335",
          "shopifyUrl": "/collections/photosmart-335"
        },
        {
          "order": 4,
          "model": "Photosmart-385",
          "shopifyUrl": "/collections/photosmart-385"
        },
        {
          "order": 5,
          "model": "Photosmart-475",
          "shopifyUrl": "/collections/photosmart-475"
        },
        {
          "order": 6,
          "model": "Photosmart-1000",
          "shopifyUrl": "/collections/photosmart-1000"
        },
        {
          "order": 7,
          "model": "Photosmart-1215",
          "shopifyUrl": "/collections/photosmart-1215"
        },
        {
          "order": 8,
          "model": "Photosmart-1315",
          "shopifyUrl": "/collections/photosmart-1315"
        },
        {
          "order": 9,
          "model": "Photosmart-2575",
          "shopifyUrl": "/collections/photosmart-2575"
        },
        {
          "order": 10,
          "model": "Photosmart-2575a",
          "shopifyUrl": "/collections/photosmart-2575a"
        },
        {
          "order": 11,
          "model": "Photosmart-2610",
          "shopifyUrl": "/collections/photosmart-2610"
        },
        {
          "order": 12,
          "model": "Photosmart-2710",
          "shopifyUrl": "/collections/photosmart-2710"
        },
        {
          "order": 13,
          "model": "Photosmart-3210",
          "shopifyUrl": "/collections/photosmart-3210"
        },
        {
          "order": 14,
          "model": "Photosmart-3210a",
          "shopifyUrl": "/collections/photosmart-3210a"
        },
        {
          "order": 15,
          "model": "Photosmart-3310",
          "shopifyUrl": "/collections/photosmart-3310"
        },
        {
          "order": 16,
          "model": "Photosmart-5510",
          "shopifyUrl": "/collections/photosmart-5510"
        },
        {
          "order": 17,
          "model": "Photosmart-5520",
          "shopifyUrl": "/collections/photosmart-5520"
        },
        {
          "order": 18,
          "model": "Photosmart-6510",
          "shopifyUrl": "/collections/photosmart-6510"
        },
        {
          "order": 19,
          "model": "Photosmart-6520",
          "shopifyUrl": "/collections/photosmart-6520"
        },
        {
          "order": 20,
          "model": "Photosmart-6521",
          "shopifyUrl": "/collections/photosmart-6521"
        },
        {
          "order": 21,
          "model": "Photosmart-7350",
          "shopifyUrl": "/collections/photosmart-7350"
        },
        {
          "order": 22,
          "model": "Photosmart-7550",
          "shopifyUrl": "/collections/photosmart-7550"
        },
        {
          "order": 23,
          "model": "Photosmart-7830",
          "shopifyUrl": "/collections/photosmart-7830"
        },
        {
          "order": 24,
          "model": "Photosmart-8230",
          "shopifyUrl": "/collections/photosmart-8230"
        },
        {
          "order": 25,
          "model": "Photosmart-8753",
          "shopifyUrl": "/collections/photosmart-8753"
        }
      ]
    },
    {
      "order": 22,
      "name": "Photosmart-Aシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Photosmart-A516",
          "shopifyUrl": "/collections/photosmart-a516"
        },
        {
          "order": 2,
          "model": "Photosmart-A528",
          "shopifyUrl": "/collections/photosmart-a528"
        },
        {
          "order": 3,
          "model": "Photosmart-A538",
          "shopifyUrl": "/collections/photosmart-a538"
        },
        {
          "order": 4,
          "model": "Photosmart-A616",
          "shopifyUrl": "/collections/photosmart-a616"
        },
        {
          "order": 5,
          "model": "Photosmart-A628",
          "shopifyUrl": "/collections/photosmart-a628"
        },
        {
          "order": 6,
          "model": "Photosmart-A716",
          "shopifyUrl": "/collections/photosmart-a716"
        },
        {
          "order": 7,
          "model": "Photosmart-A828",
          "shopifyUrl": "/collections/photosmart-a828"
        }
      ]
    },
    {
      "order": 23,
      "name": "Photosmart-Bシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Photosmart-B109A",
          "shopifyUrl": "/collections/photosmart-b109a"
        }
      ]
    },
    {
      "order": 24,
      "name": "Photosmart-Cシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Photosmart-C3175",
          "shopifyUrl": "/collections/photosmart-c3175"
        },
        {
          "order": 2,
          "model": "Photosmart-C3180",
          "shopifyUrl": "/collections/photosmart-c3180"
        },
        {
          "order": 3,
          "model": "Photosmart-C4175",
          "shopifyUrl": "/collections/photosmart-c4175"
        },
        {
          "order": 4,
          "model": "Photosmart-C4180",
          "shopifyUrl": "/collections/photosmart-c4180"
        },
        {
          "order": 5,
          "model": "Photosmart-C4275",
          "shopifyUrl": "/collections/photosmart-c4275"
        },
        {
          "order": 6,
          "model": "Photosmart-C4380",
          "shopifyUrl": "/collections/photosmart-c4380"
        },
        {
          "order": 7,
          "model": "Photosmart-C4400",
          "shopifyUrl": "/collections/photosmart-c4400"
        },
        {
          "order": 8,
          "model": "Photosmart-C4480",
          "shopifyUrl": "/collections/photosmart-c4480"
        },
        {
          "order": 9,
          "model": "Photosmart-C4486",
          "shopifyUrl": "/collections/photosmart-c4486"
        },
        {
          "order": 10,
          "model": "Photosmart-C4490",
          "shopifyUrl": "/collections/photosmart-c4490"
        },
        {
          "order": 11,
          "model": "Photosmart-C4580",
          "shopifyUrl": "/collections/photosmart-c4580"
        },
        {
          "order": 12,
          "model": "Photosmart-C5175",
          "shopifyUrl": "/collections/photosmart-c5175"
        },
        {
          "order": 13,
          "model": "Photosmart-C5180",
          "shopifyUrl": "/collections/photosmart-c5180"
        },
        {
          "order": 14,
          "model": "Photosmart-C5280",
          "shopifyUrl": "/collections/photosmart-c5280"
        },
        {
          "order": 15,
          "model": "Photosmart-C5380",
          "shopifyUrl": "/collections/photosmart-c5380"
        },
        {
          "order": 16,
          "model": "Photosmart-C6175",
          "shopifyUrl": "/collections/photosmart-c6175"
        },
        {
          "order": 17,
          "model": "Photosmart-C6280",
          "shopifyUrl": "/collections/photosmart-c6280"
        },
        {
          "order": 18,
          "model": "Photosmart-C6380",
          "shopifyUrl": "/collections/photosmart-c6380"
        },
        {
          "order": 19,
          "model": "Photosmart-C7180",
          "shopifyUrl": "/collections/photosmart-c7180"
        },
        {
          "order": 20,
          "model": "Photosmart-C8180",
          "shopifyUrl": "/collections/photosmart-c8180"
        }
      ]
    },
    {
      "order": 25,
      "name": "Photosmart-Dシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Photosmart-D5160",
          "shopifyUrl": "/collections/photosmart-d5160"
        },
        {
          "order": 2,
          "model": "Photosmart-D5360",
          "shopifyUrl": "/collections/photosmart-d5360"
        },
        {
          "order": 3,
          "model": "Photosmart-D5460",
          "shopifyUrl": "/collections/photosmart-d5460"
        },
        {
          "order": 4,
          "model": "Photosmart-D7160",
          "shopifyUrl": "/collections/photosmart-d7160"
        },
        {
          "order": 5,
          "model": "Photosmart-D7360",
          "shopifyUrl": "/collections/photosmart-d7360"
        }
      ]
    },
    {
      "order": 26,
      "name": "Photosmart-Pシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Photosmart-P1000",
          "shopifyUrl": "/collections/photosmart-p1000"
        },
        {
          "order": 2,
          "model": "Photosmart-P1100",
          "shopifyUrl": "/collections/photosmart-p1100"
        }
      ]
    },
    {
      "order": 27,
      "name": "Photosmart-Plusシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Photosmart-Plus-B209A",
          "shopifyUrl": "/collections/photosmart-plus-b209a"
        },
        {
          "order": 2,
          "model": "Photosmart-Plus-B210a",
          "shopifyUrl": "/collections/photosmart-plus-b210a"
        }
      ]
    },
    {
      "order": 28,
      "name": "Photosmart-Premiumシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Photosmart-Premium-C309G",
          "shopifyUrl": "/collections/photosmart-premium-c309g"
        },
        {
          "order": 2,
          "model": "Photosmart-Premium-C310c",
          "shopifyUrl": "/collections/photosmart-premium-c310c"
        },
        {
          "order": 3,
          "model": "Photosmart-Premium-FAX-All-in-One-C309a",
          "shopifyUrl": "/collections/photosmart-premium-fax-all-in-one-c309a"
        }
      ]
    },
    {
      "order": 29,
      "name": "Photosmart-Wirelessシリーズ",
      "models": [
        {
          "order": 1,
          "model": "Photosmart-Wireless-B109N",
          "shopifyUrl": "/collections/photosmart-wireless-b109n"
        },
        {
          "order": 2,
          "model": "Photosmart-Wireless-B110a",
          "shopifyUrl": "/collections/photosmart-wireless-b110a"
        }
      ]
    },
    {
      "order": 30,
      "name": "Pictyシリーズ(NEC)",
      "models": [
        {
          "order": 1,
          "model": "Picty-80L",
          "shopifyUrl": "/collections/picty-80l"
        },
        {
          "order": 2,
          "model": "Picty-100L",
          "shopifyUrl": "/collections/picty-100l"
        },
        {
          "order": 3,
          "model": "Picty-110",
          "shopifyUrl": "/collections/picty-110"
        },
        {
          "order": 4,
          "model": "Picty-110R",
          "shopifyUrl": "/collections/picty-110r"
        },
        {
          "order": 5,
          "model": "Picty-320",
          "shopifyUrl": "/collections/picty-320"
        },
        {
          "order": 6,
          "model": "Picty-400",
          "shopifyUrl": "/collections/picty-400"
        },
        {
          "order": 7,
          "model": "Picty-500",
          "shopifyUrl": "/collections/picty-500"
        },
        {
          "order": 8,
          "model": "Picty-700",
          "shopifyUrl": "/collections/picty-700"
        },
        {
          "order": 9,
          "model": "Picty-760",
          "shopifyUrl": "/collections/picty-760"
        },
        {
          "order": 10,
          "model": "Picty-770",
          "shopifyUrl": "/collections/picty-770"
        },
        {
          "order": 11,
          "model": "Picty-870",
          "shopifyUrl": "/collections/picty-870"
        },
        {
          "order": 12,
          "model": "Picty-820G",
          "shopifyUrl": "/collections/picty-820g"
        },
        {
          "order": 13,
          "model": "Picty-820W",
          "shopifyUrl": "/collections/picty-820w"
        },
        {
          "order": 14,
          "model": "Picty-860",
          "shopifyUrl": "/collections/picty-860"
        },
        {
          "order": 15,
          "model": "Picty-880",
          "shopifyUrl": "/collections/picty-880"
        },
        {
          "order": 16,
          "model": "Picty-880S",
          "shopifyUrl": "/collections/picty-880s"
        },
        {
          "order": 17,
          "model": "Picty-900",
          "shopifyUrl": "/collections/picty-900"
        },
        {
          "order": 18,
          "model": "Picty-920",
          "shopifyUrl": "/collections/picty-920"
        },
        {
          "order": 19,
          "model": "Picty-920S",
          "shopifyUrl": "/collections/picty-920s"
        },
        {
          "order": 20,
          "model": "Picty-960",
          "shopifyUrl": "/collections/picty-960"
        },
        {
          "order": 21,
          "model": "Picty-970",
          "shopifyUrl": "/collections/picty-970"
        },
        {
          "order": 22,
          "model": "Picty-4000",
          "shopifyUrl": "/collections/picty-4000"
        }
      ]
    },
    {
      "order": 31,
      "name": "PCPシリーズ(CASIO)",
      "models": [
        {
          "order": 1,
          "model": "PCP-10",
          "shopifyUrl": "/collections/pcp-10"
        },
        {
          "order": 2,
          "model": "PCP-20",
          "shopifyUrl": "/collections/pcp-20"
        },
        {
          "order": 3,
          "model": "PCP-30",
          "shopifyUrl": "/collections/pcp-30"
        },
        {
          "order": 4,
          "model": "PCP-40",
          "shopifyUrl": "/collections/pcp-40"
        },
        {
          "order": 5,
          "model": "PCP-45",
          "shopifyUrl": "/collections/pcp-45"
        },
        {
          "order": 6,
          "model": "PCP-48",
          "shopifyUrl": "/collections/pcp-48"
        },
        {
          "order": 7,
          "model": "PCP-49",
          "shopifyUrl": "/collections/pcp-49"
        },
        {
          "order": 8,
          "model": "PCP-50",
          "shopifyUrl": "/collections/pcp-50"
        },
        {
          "order": 9,
          "model": "PCP-51",
          "shopifyUrl": "/collections/pcp-51"
        },
        {
          "order": 10,
          "model": "PCP-60",
          "shopifyUrl": "/collections/pcp-60"
        },
        {
          "order": 11,
          "model": "PCP-70",
          "shopifyUrl": "/collections/pcp-70"
        },
        {
          "order": 12,
          "model": "PCP-80",
          "shopifyUrl": "/collections/pcp-80"
        },
        {
          "order": 13,
          "model": "PCP-100",
          "shopifyUrl": "/collections/pcp-100"
        },
        {
          "order": 14,
          "model": "PCP-120",
          "shopifyUrl": "/collections/pcp-120"
        },
        {
          "order": 15,
          "model": "PCP-200",
          "shopifyUrl": "/collections/pcp-200"
        },
        {
          "order": 16,
          "model": "PCP-250",
          "shopifyUrl": "/collections/pcp-250"
        },
        {
          "order": 17,
          "model": "PCP-300",
          "shopifyUrl": "/collections/pcp-300"
        },
        {
          "order": 18,
          "model": "PCP-400",
          "shopifyUrl": "/collections/pcp-400"
        },
        {
          "order": 19,
          "model": "PCP-500",
          "shopifyUrl": "/collections/pcp-500"
        },
        {
          "order": 20,
          "model": "PCP-700",
          "shopifyUrl": "/collections/pcp-700"
        },
        {
          "order": 21,
          "model": "PCP-800",
          "shopifyUrl": "/collections/pcp-800"
        },
        {
          "order": 22,
          "model": "PCP-1000",
          "shopifyUrl": "/collections/pcp-1000"
        },
        {
          "order": 23,
          "model": "PCP-1200",
          "shopifyUrl": "/collections/pcp-1200"
        },
        {
          "order": 24,
          "model": "PCP-1300",
          "shopifyUrl": "/collections/pcp-1300"
        },
        {
          "order": 25,
          "model": "PCP-1400",
          "shopifyUrl": "/collections/pcp-1400"
        },
        {
          "order": 26,
          "model": "PCP-2000",
          "shopifyUrl": "/collections/pcp-2000"
        },
        {
          "order": 27,
          "model": "PCP-2100",
          "shopifyUrl": "/collections/pcp-2100"
        },
        {
          "order": 28,
          "model": "PCP-2200",
          "shopifyUrl": "/collections/pcp-2200"
        },
        {
          "order": 29,
          "model": "PCP-2300",
          "shopifyUrl": "/collections/pcp-2300"
        },
        {
          "order": 30,
          "model": "PCP-2400",
          "shopifyUrl": "/collections/pcp-2400"
        },
        {
          "order": 31,
          "model": "PCP-2500",
          "shopifyUrl": "/collections/pcp-2500"
        }
      ]
    },
    {
      "order": 32,
      "name": "PSCシリーズ",
      "models": [
        {
          "order": 1,
          "model": "PSC-750",
          "shopifyUrl": "/collections/psc-750"
        },
        {
          "order": 2,
          "model": "PSC-1210",
          "shopifyUrl": "/collections/psc-1210"
        },
        {
          "order": 3,
          "model": "PSC-1315",
          "shopifyUrl": "/collections/psc-1315"
        },
        {
          "order": 4,
          "model": "PSC-1350",
          "shopifyUrl": "/collections/psc-1350"
        },
        {
          "order": 5,
          "model": "PSC-1500",
          "shopifyUrl": "/collections/psc-1500"
        },
        {
          "order": 6,
          "model": "PSC-1510",
          "shopifyUrl": "/collections/psc-1510"
        },
        {
          "order": 7,
          "model": "PSC-1610",
          "shopifyUrl": "/collections/psc-1610"
        },
        {
          "order": 8,
          "model": "PSC-2110",
          "shopifyUrl": "/collections/psc-2110"
        },
        {
          "order": 9,
          "model": "PSC-2150",
          "shopifyUrl": "/collections/psc-2150"
        },
        {
          "order": 10,
          "model": "PSC-2310",
          "shopifyUrl": "/collections/psc-2310"
        },
        {
          "order": 11,
          "model": "PSC-2355",
          "shopifyUrl": "/collections/psc-2355"
        },
        {
          "order": 12,
          "model": "PSC-2450",
          "shopifyUrl": "/collections/psc-2450"
        },
        {
          "order": 13,
          "model": "PSC-2550",
          "shopifyUrl": "/collections/psc-2550"
        }
      ]
    },
    {
      "order": 33,
      "name": "スピークスプラスシリーズ(NEC)",
      "models": [
        {
          "order": 1,
          "model": "SP-P70H",
          "shopifyUrl": "/collections/sp-p70h"
        },
        {
          "order": 2,
          "model": "SP-P70HW",
          "shopifyUrl": "/collections/sp-p70hw"
        }
      ]
    },
    {
      "order": 34,
      "name": "ファクシミリ複合機見楽る-AIシリーズ(SHARP)",
      "models": [
        {
          "order": 1,
          "model": "AI-M1000",
          "shopifyUrl": "/collections/ai-m1000"
        }
      ]
    },
    {
      "order": 35,
      "name": "ファクシミリ複合機見楽る-UXシリーズ(SHARP)",
      "models": [
        {
          "order": 1,
          "model": "UX-MF10CL",
          "shopifyUrl": "/collections/ux-mf10cl"
        },
        {
          "order": 2,
          "model": "UX-MF10CW",
          "shopifyUrl": "/collections/ux-mf10cw"
        },
        {
          "order": 3,
          "model": "UX-MF25CL",
          "shopifyUrl": "/collections/ux-mf25cl"
        },
        {
          "order": 4,
          "model": "UX-MF25CW",
          "shopifyUrl": "/collections/ux-mf25cw"
        },
        {
          "order": 5,
          "model": "UX-MF30CL",
          "shopifyUrl": "/collections/ux-mf30cl"
        },
        {
          "order": 6,
          "model": "UX-MF30CW",
          "shopifyUrl": "/collections/ux-mf30cw"
        },
        {
          "order": 7,
          "model": "UX-MF40CL",
          "shopifyUrl": "/collections/ux-mf40cl"
        },
        {
          "order": 8,
          "model": "UX-MF40CW",
          "shopifyUrl": "/collections/ux-mf40cw"
        },
        {
          "order": 9,
          "model": "UX-MF50CL",
          "shopifyUrl": "/collections/ux-mf50cl"
        },
        {
          "order": 10,
          "model": "UX-MF50CW",
          "shopifyUrl": "/collections/ux-mf50cw"
        },
        {
          "order": 11,
          "model": "UX-MF60CL",
          "shopifyUrl": "/collections/ux-mf60cl"
        },
        {
          "order": 12,
          "model": "UX-MF60CW",
          "shopifyUrl": "/collections/ux-mf60cw"
        },
        {
          "order": 13,
          "model": "UX-MF70CL",
          "shopifyUrl": "/collections/ux-mf70cl"
        },
        {
          "order": 14,
          "model": "UX-MF70CW",
          "shopifyUrl": "/collections/ux-mf70cw"
        },
        {
          "order": 15,
          "model": "UX-MF80CL",
          "shopifyUrl": "/collections/ux-mf80cl"
        },
        {
          "order": 16,
          "model": "UX-MF80CW",
          "shopifyUrl": "/collections/ux-mf80cw"
        }
      ]
    }
  ]
};
